module.exports = __webpack_public_path__ + "static/media/Pic-0518.a1dc3b19.jpg";